import React from 'react'

import { cn } from '~/styled'

import { Tile } from '../tile/Tile'
import { SkeletonLoader } from './Skeleton'

export const SkeletonPanelList = ({ className }: { className?: string }) => (
  <Tile className={cn('px-6', 'flex-col', 'w-full', className)}>
    <div className="border-grey-100 flex flex-wrap items-center gap-4 border-b py-4 last:border-b-0">
      <SkeletonLoader className="size-10 rounded-full" />
      <div className="grow">
        <SkeletonLoader className="h-4 w-2/3 rounded-full" />
      </div>
      <SkeletonLoader className="h-8 w-28 rounded-md" />
    </div>
  </Tile>
)
